import Provider from './ProviderPresenter';
import { useSnackbar } from 'notistack';
import theme from './styles/theme';
import colorSet from './styles/colorSet';

export { useSnackbar, theme, colorSet };
export default Provider;
